module.exports = __webpack_public_path__ + "media/images/stripe/blue-on-light@3x-08a8b04c68e0cf242d222944daed2d1f.png";